export default IconXd => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-xd" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 8l4 8" />
  <path d="M6 16l4 -8" />
  <path d="M14 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z" />
</svg>`;